import { NoOpFlagsManager } from '@databases/flags';
import { NoOpPanelManager } from '@databases/panel/managers';
import { PluginKey, type PluginsState } from '@databases/plugins';

import { NoOpPreviewPanelAFMBridge } from '@canvas/databases-bridge-api';

import { createBaseModeConfig, type ModeConfig } from './default-mode-config';

const pluginsState: PluginsState = {
  [PluginKey.CELL_SELECTION]: () => false,
  [PluginKey.COMMENTS]: () => false,
  [PluginKey.CONTEXT_MENU]: () => false,
  [PluginKey.EDIT_CONTENT]: () => false,
  [PluginKey.QUICK_CALCULATIONS]: () => false,
  [PluginKey.VIEW_SETTINGS_ACTIONS]: () => false,
};

export function createMobileModeConfig(): ModeConfig {
  return createBaseModeConfig({
    plugins: pluginsState,
    dependencies: {
      FlagsManager: () => new NoOpFlagsManager(),
      PanelManager: () => new NoOpPanelManager(),
      PreviewPanelAFMBridge: () => new NoOpPreviewPanelAFMBridge(),
    },
  });
}
